import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import {Objects} from "components";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

export default class Scores extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Dispatch._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {pages, limit, loading} = this.state;
		const {data} = this.props;
		const columns = [
			{
				Header: "Dispatcher",
				id: "display_name",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.DisplayName,
				Cell: (props) => {
					let {original} = props;
					return (
						<span>
							<Link onClick={() => {this.props.navToChart(original.DisplayName)}}>
								{original.DisplayName}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Books",
				id: "books",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.Books,
			},
			{
				Header: "Phone Calls",
				id: "phone_calls",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.PhoneTotals,
			},
			{
				Header: "Avg Time Between Activities",
				id: "avg_call_time",
				/** @param {Dispatch_Object} obj */
				accessor: obj => obj.AvgCallTime,
			},

		];
		return (
			<div className={'box-body'}>
				<Card>
					<CardContent>
						<ReactTable
							key={this.state.key}
							columns={columns}
							onPageSizeChange={this.onPageSizeChange}
							pageSize={limit}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName))}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: 'ranking'
								}
							]}
							showPagination={true}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
			</div>
		)
	}
}
